import { render, staticRenderFns } from "./PlatformDisplay.vue?vue&type=template&id=9ef418ea&"
import script from "./PlatformDisplay.vue?vue&type=script&lang=ts&"
export * from "./PlatformDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports